export default __webpack_public_path__ + "static/media/CNo.26-0.fe012751.jpg";